import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  blueSkyCardHeader,
  graniteCardHeader,
  pineCardHeader,
  fieldsCardHeader,
  grayColor
} from "../../material-dashboard-pro-react.js";
const cardIconStyle = {
  cardIcon: {
    "&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader,&$blueSkyCardHeader,&$graniteCardHeader,&$pineCardHeader,&$fieldsCardHeader": {
      borderRadius: "3px",
      backgroundColor: grayColor[0],
      padding: "15px",
      marginTop: "-20px",
      marginRight: "15px",
      float: "left"
    }
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  blueSkyCardHeader,
  graniteCardHeader,
  pineCardHeader,
  fieldsCardHeader
};

export default cardIconStyle;
